import React, {ReactNode, useEffect} from 'react'

export interface ISelectOption {
    value: string
    text: string
}

interface ISelectInput {
    changeHandler: (data: any) => any,
    blurHandler?: (data: any) => any,
    value: string|number|string[],
    disabled?: boolean,
    label?: string | ReactNode
    name: string,
    customClassName?: string,
    customLabelClassName?: string,
    customLabel?: React.ComponentType
    validationError?: boolean,
    validationErrorDescription?: string,
    require?: boolean,
    id?: string,
    options: ISelectOption[],
    isMultiple?: boolean
}

const FormSelect: React.FC<ISelectInput> = (
    {
        changeHandler,
        disabled = false,
        label,
        name,
        customClassName,
        customLabelClassName,
        customLabel,
        validationError,
        validationErrorDescription,
        value,
        blurHandler,
        require = true,
        id,
        options,
        isMultiple = false
    }
) => {

    return (
        <>
            {customLabel ?
                (
                    <div className="flex">
                        {/*@ts-ignore*/}
                        {customLabel}
                    </div>
                )
                :
                label &&
                (
                    <>
                        <label
                            className={`block text-gray-600 text-left font-medium mb-1 ${customLabelClassName ? customLabelClassName : ""}`}
                            htmlFor={name}
                        >
                            {label}
                            {require && <span className="text-red-500 px-1">*</span>}
                        </label>
                    </>
                )
            }
            <select
                id={id}
                className={`form-input border px-2 pr-5 py-1 border-slate-200 rounded-md w-full ${customClassName ? customClassName : ""} ${validationError ? "border border-red-500" : ""}`}
                name={name}
                onChange={changeHandler}
                onBlur={blurHandler}
                // defaultValue={value}
                value={value}
                disabled={disabled}
                required={require}
                multiple={isMultiple}
                style={{backgroundPosition: 'right 0rem center'}}
            >
                {options.map((o, k) => <option value={o.value} key={k}>{o.text}</option>)}
            </select>
            {
                validationErrorDescription && (
                    <div className="text-xs text-left text-red-500">
                        {validationErrorDescription}
                    </div>
                )
            }
        </>
    )
}

export default FormSelect